import { render, staticRenderFns } from "./orderDetailRefundList.vue?vue&type=template&id=c8d00a34"
import script from "./orderDetailRefundList.vue?vue&type=script&lang=js"
export * from "./orderDetailRefundList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports